<template>
    <div id="container-navbar-header">
        <a
            :href="linkFacebook"
            target="_blank"
            id="logo"
        >
            <img src="./images/logo simac.svg">
        </a>
        <b-navbar :toggleable="Colapse" type="dark" :class="{'nav':!showMenu,'nav2':showMenu}">
            <b-navbar-toggle id="nav-toggler" target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item
                        v-for="(icon,index) in icons"
                        :key="index"
                        :href="icon.href"
                        target="_blank"
                        class="nav-link"
                    >
                        <img
                            :id="icon.id"
                            :src="icon.src"
                            @mouseover="Change_Src(icon.id, icon.srcHover)"
                            @mouseleave="Change_Src(icon.id, icon.src)"
                            class="img-nav"
                        >
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import queries from '@/services/links_queries.js';
    import items from './items.js';

    export default {
        name: 'NavbarHeader',

        data(){
            return {
                icons: items,
                linkFacebook: queries.facebook,
            }
        },

        computed:{
            ...mapState('station_id',['showMenu']),

            Colapse() {
                if (this.showMenu) {
                    return 'xxxl'
                }else {
                    return 'xl'
                }
            }
        },

        methods: {
            Change_Src(id,src){
                let element = document.getElementById(id);
                element.src = src;
            }
        }
    };
</script>

<style scoped lang="scss">
    .nav{
        background-color: $bg-dark-color-transparent;
        border-bottom-left-radius: 1em;
        box-shadow: .2em .2em .5em $dark-color;
        justify-content: center;
        position: absolute;
        right: 0;
        text-align: center;
        top: 0;
        z-index: 2;
    }

    .nav2{
        background-color: $bg-dark-color-transparent;
        border-bottom-left-radius: 1em;
        justify-content: center;
        position: absolute;
        right: 35em;
        text-align: center;
        top:0;
        transition: right 0.5s;
        z-index: 1;
    }

    #logo{
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 1;
        width: 12em;
    }

    .nav-link {
        padding: .4em;
        .img-nav{
            height: 2em;
        }
    }

    @media (max-width: 600px) {
        .nav-link {
            padding: .4em 0;
            .img-nav{
                height: 1.5em;
            }
        }

        .navbar {
            justify-content: center;
        }

        #logo {
            width: 10em;
        }

        .nav2 {
            right: 0;
        }
    }

    @media (max-height: 500px) {
        .navbar-nav {
            flex-flow: row nowrap;
        }

        .navbar {
            flex-flow: row nowrap;
            display: inline-flex;
            font-size: .9em;
        }

        .img-nav {
            height: 1.5em;
            margin: 0 .35em;
        }
    }

    @media (min-width: 1500px) {
        .nav2 {
            #nav-toggler {
                font-size: 1.5em;
            }
        }

        #logo {
            width: 15em;
        }

        .img-nav {
            height: 2.5em;
        }

        .nav-link {
            padding: .6em;

            .img-nav{
                height: 2.5em;
            }
        }

        .nav2{
            right: 45em;
        }
    }
</style>